import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  templateUrl: './home-page.html',
  styleUrls: ['./home-page.component.scss']
})

export class HomePageComponent implements OnInit, OnDestroy {

  constructor() {
              }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  animelist() {
  }

}
